import { AbstractLookupStore, AbstractGetAllStore } from "../common/AbstractStores";
import { CaldaiaDto } from "../generated";
import Dispatcher from "../common/dispatcher";
import Actions from "./caldaieActions";
import { groupBy } from "lodash";

class __CaldaieStore extends AbstractGetAllStore<CaldaiaDto>{
    constructor() {
        super(x => x.idCaldaia.toString());
        Dispatcher
            .onfunction(Actions.getCaldaia, result => this.updateOrAdd(result!))
            .onfunction(Actions.getAll, result => this.setAll(result!))
            .onfunction(Actions.add, result => this.updateOrAdd(result))
            .onfunction(Actions.update, result => this.updateOrAdd(result))
            .onfunction(Actions.delete, result => {
                if (result.deleteOk) this.delete(result.idCaldaia.toString());
            })
    }

    public use(id: number | null) {
        return this.useWithAction(() => id && Actions.getCaldaia(id), id?.toString() ?? null)
    }
    public useAll() {
        return this.useAllWithAction(() => Actions.getAll())
    }
}
export const CaldaieStore = new __CaldaieStore();

class __CaldaieByMarcaStore extends AbstractLookupStore<CaldaiaDto>{
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getAll, result => {
                const groups = groupBy(result);
                for (const key in groups) {
                    const data = groups[key];
                    this.set(key, data);
                }
            })
            .onfunction(Actions.add, result => this.addOne(result.marcaCaldaia!, result, x => x.idCaldaia.toString()))
            .onfunction(Actions.update, result => this.updateOne(result.marcaCaldaia!, result, x => x.idCaldaia.toString()))
            .onfunction(Actions.getCaldaieByMarca, ({ marca, data }) => this.set(marca, data))
    }

    public useMarca = (marca: string) => this.useStoreWithAction(marca, () => Actions.getCaldaieByMarca(marca))
}
export const CaldaieByMarcaStore = new __CaldaieByMarcaStore();